import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

import { payrollIntegrationOptions } from '../utils/constants'

// Assets //
import TripletexLogo from '../assets/img/tripletex_logo.svg'
import VismaLogo from '../assets/img/visma_logo.png';
import XledgerLogo from '../assets/img/xledger_logo.png';
import DnbLogo from '../assets/img/dnb_logo.svg';
import TimebankLogo from '../assets/img/timebank_logo.svg'

export const getIntegrationProduct = (product) => {
    switch (product) {
        case payrollIntegrationOptions.TRIPLETEX:
            return TripletexLogo;
        case payrollIntegrationOptions.VISMA:
            return VismaLogo;
        case payrollIntegrationOptions.XLEDGER:
            return XledgerLogo;
        case payrollIntegrationOptions.DNBREGNSKAP:
            return DnbLogo;
        default:
            break;
    }
}

export const getIntegrationIconWithStatus = (config, int_details, t, showTimebankLogo) => {
    const __showTimebankLogo = showTimebankLogo && config?.integration_details?.product && int_details
        && ((int_details?.total_hours_overtime + int_details?.total_hours_normal) === 0)
        && int_details.status !== 'draft' && int_details.data?.timeBank && int_details.data.timeBank.length;
    return (
        <>
            {
                config?.integration_details?.product && (int_details.int_id) && (
                    <img
                        src={getIntegrationProduct(config.integration_details.product)}
                        width={24}
                        height={24}
                        alt='int'
                        title={`${t('Synced with')} ${config?.integration_details?.product}`}
                        className='m-1'
                    />
                )
            }
            {int_details.int_status === 'failed' &&
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {int_details && int_details.int_data && int_details.int_data.messages
                                && int_details.int_data.messages[0] && int_details.int_data.messages[0].message ?
                                `${int_details.int_data.messages[0].message} (${t("from")} ${config?.integration_details?.product || t('Integrations')})` :
                                `${t("Something went wrong")} (${t("from")} ${config?.integration_details?.product || t('Integrations')})!`}
                            <br />
                            {t('Please reset and try again.')}
                        </Tooltip>
                    }
                >
                    <div className='ml-10'>
                        <i className="fa fa-exclamation m-2" />
                    </div>
                </OverlayTrigger>
            }
            {int_details.int_is_partial_fail && int_details.int_status !== 'failed' &&
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-partial-fail">
                            {`${t("Overtime or Additional Payment Sync Failed")} (${t("from")} ${config?.integration_details?.product || t('Integrations')})!`}
                            <br />
                            {t('Please reset and try again.')}
                        </Tooltip>
                    }
                >
                    <div className='ml-10'>
                        <i className="fa fa-exclamation m-2" />
                    </div>
                </OverlayTrigger>
            }
            {!!__showTimebankLogo && (
                <img
                    src={TimebankLogo}
                    width={24}
                    height={24}
                    alt='int'
                    title={`${t('Timebank')}`}
                />
            )
            }
        </>
    )
}

export const getIntegrationIconForExtraPayments = (config, t) => {
    return (
        <>
            {config &&
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {t("One of the extra payments failed to sync")}
                        </Tooltip>
                    }
                >
                    <div className='ml-10'>
                        <i className="fa fa-exclamation m-2" />
                    </div>
                </OverlayTrigger>
            }
        </>
    )
}

export const isUserUpdatedValuesForVisma = (commonStore, add, values, t, result, callBackFun) => {
    if (commonStore.config?.integration_details?.product === payrollIntegrationOptions.VISMA && values.user_type !== 'admin' && result?.int_user?.status === 'failed') {
        if (!add) {
            const str = t(`${result.int_user.data?.validationResults.length && result.int_user.data?.validationResults[0]?.message ?
                result.int_user.data?.validationResults[0]?.message
                : result.int_user.data.message ?
                    result.int_user.data.message
                    :
                    "Have you updated required User's details"
                }`);
            return confirmAlert({
                title: `${t('Have you Updated required details')} ?`,
                message: str,
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: () => {
                            setTimeout(() => {
                                callBackFun(values, result, add)
                            }, 10)
                        },
                    },
                    {
                        label: t('No')
                    },
                ],
            })
        }
    }
    else {
        callBackFun(values, result, add)
    }
}